module.exports = __webpack_public_path__ + "static/media/Test12.413cb506.bmp";